/* Goldenhands theme JS - vanilla, progressive enhancement.
   Cart drawer, menu drawer, search, quick view, qty steppers, gallery (functional)
   + theme toggle, sticky header, reveal-on-scroll, image fallback, notice rotator (design). */
(function () {
  'use strict';
  var root = document.documentElement;
  var money = function (cents) { return '£' + (cents / 100).toFixed(2); };

  /* ---------- Drawers & overlay ---------- */
  var overlay = document.getElementById('overlay');
  // The menu drawer is authored inside the sticky header, which is its own stacking
  // context (z-index) - that traps the drawer BENEATH the overlay, dimming it and
  // stealing its clicks. Re-parent it to <body> so it sits above the overlay.
  var _menuDrawer = document.getElementById('menu-drawer');
  if (_menuDrawer && _menuDrawer.parentElement !== document.body) { document.body.appendChild(_menuDrawer); }
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var opener = document.querySelector('[data-drawer-open="' + el.id + '"]');
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      var opener = document.querySelector('[data-drawer-open="' + d.id + '"]');
      if (opener) opener.setAttribute('aria-expanded', 'false');
    });
    if (overlay && !(document.getElementById('qv') && document.getElementById('qv').classList.contains('is-open'))) {
      overlay.classList.remove('is-open');
    }
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) { openDrawer(document.getElementById(openBtn.getAttribute('data-drawer-open'))); return; }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) { closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Header search toggle ---------- */
  var searchToggle = document.getElementById('search-toggle');
  var headerSearch = document.getElementById('header-search');
  if (searchToggle && headerSearch) {
    searchToggle.addEventListener('click', function () {
      headerSearch.classList.toggle('is-open');
      if (headerSearch.classList.contains('is-open')) {
        var i = headerSearch.querySelector('input'); if (i) i.focus();
      }
    });
    // Close the drop-down bar the moment focus moves elsewhere - in particular when the
    // Cloud Search app opens its full-screen overlay (it focuses its own input), so
    // closing the overlay never leaves our bar stranded under the header.
    document.addEventListener('focusin', function (e) {
      if (!headerSearch.classList.contains('is-open')) return;
      if (headerSearch.contains(e.target) || e.target.closest('#search-toggle')) return;
      headerSearch.classList.remove('is-open');
    });
  }

  /* Cloud Search app detection: when present, it supplies the search suggestions UI,
     so the theme's own predictive panel stands down rather than doubling up. */
  var cloudSearchPresent = !!document.querySelector('script[src*="cloudsearch"], link[href*="cloudsearch"]');

  /* ---------- Theme toggle ---------- */
  var themeBtns = [document.getElementById('themeBtn'), document.getElementById('themeBtn2')];
  function currentTheme() {
    var set = root.getAttribute('data-theme');
    if (set === 'dark' || set === 'light') return set;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  function syncThemeBtn() {
    var dark = currentTheme() === 'dark';
    themeBtns.forEach(function (b) {
      if (!b) return;
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      b.setAttribute('aria-label', dark ? 'Switch to light theme' : 'Switch to dark theme');
      var label = b.querySelector('[data-theme-label]');
      if (label) label.textContent = dark ? 'Light theme' : 'Dark theme';
    });
  }
  themeBtns.forEach(function (b) {
    if (!b) return;
    b.addEventListener('click', function () {
      var next = currentTheme() === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', next);
      try { localStorage.setItem('gh-theme', next); } catch (e) {}
      syncThemeBtn();
    });
  });
  syncThemeBtn();

  /* ---------- Sticky header: shadow when scrolled, hide on scroll down, float back on scroll up ---------- */
  var head = document.getElementById('head');
  if (head) {
    var lastY = window.scrollY, ticking = false;
    function updHead() {
      var y = window.scrollY;
      head.classList.toggle('is-stuck', y > 12);
      // Never hide the header while something inside or beside it is open: a drawer, the
      // search bar, the Collections accordion or the filter panel. Opening an in-flow
      // accordion shifts the page and scroll anchoring bumps scrollY, which would
      // otherwise read as "scrolling down" and slide the header (accordion included)
      // off the top of the screen.
      var drawerOpen = document.querySelector('.drawer.is-open, .hdd[open], .facets-collapse[open]') ||
        (headerSearch && headerSearch.classList.contains('is-open'));
      if (!drawerOpen && y > 110 && y > lastY + 4) {
        head.classList.add('head--hidden');       // scrolling down
      } else if (y < lastY - 4 || y <= 110) {
        head.classList.remove('head--hidden');     // scrolling up, or near the top
      }
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(updHead); ticking = true; }
    }, { passive: true });
    updHead();
  }

  /* Header nav vs burger is handled entirely in CSS by width now - no JS toggling of the
     burger's display (that was hiding it in previews that don't fire a resize event). */

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty [data-qty]');
    if (!btn || btn.closest('.cart__item')) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += (btn.getAttribute('data-qty') === 'up' ? 1 : -1);
    if (val < 1) val = 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.getAttribute('data-full') || t.src; }
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  /* ---------- Cart ---------- */
  var cartCountEls = document.querySelectorAll('[data-cart-count]');
  function setCount(n) {
    cartCountEls.forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }
  var threshold = parseFloat(document.body.getAttribute('data-free-shipping') || '0') * 100;

  function ghEsc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  // Offers are read once from a JSON block Liquid prints from Theme settings, so adding
  // a future deal is a settings change, not a code change.
  var _offers = null;
  function getOffers() {
    if (_offers) return _offers;
    var el = document.getElementById('gh-offers');
    try { _offers = el ? (JSON.parse(el.textContent) || []) : []; } catch (e) { _offers = []; }
    return _offers;
  }
  // One progress bar per offer, styled like the free-shipping bar. An item counts toward
  // an offer only when it satisfies every matcher the offer sets (price, title, type) -
  // blanks are ignored - which mirrors how the automatic discount's collection is defined.
  function offerBar(cart, offer) {
    var need = parseInt(offer.qty, 10);
    if (!need || need < 1) return '';
    var priceP = offer.price ? Math.round(parseFloat(offer.price) * 100) : 0;
    var titleQ = (offer.title || '').toLowerCase();
    var typeQ = offer.type || '';
    var have = cart.items.reduce(function (n, it) {
      var okType = !typeQ || (it.product_type || '') === typeQ;
      var okPrice = !priceP || it.price === priceP;
      var okTitle = !titleQ || ((it.product_title || it.title || '').toLowerCase().indexOf(titleQ) !== -1);
      return n + (okType && okPrice && okTitle ? it.quantity : 0);
    }, 0);
    if (have <= 0) return '';
    var name = ghEsc(offer.label || 'the offer');
    if (have >= need) {
      return '<div class="cart-progress cart-progress--done">' + name + ' - it\'s in your basket.</div>';
    }
    var pct = Math.min(100, (have / need) * 100);
    return '<div class="cart-progress">Add ' + (need - have) + ' more for ' + name +
      '<div class="cart-progress__track"><div class="cart-progress__fill" style="width:' + pct + '%"></div></div></div>';
  }
  function offerBars(cart) {
    return getOffers().map(function (o) { return offerBar(cart, o); }).join('');
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="empty"><p class="sparkle" aria-hidden="true">\u22C6\u02D6\u207A\u2027\u208A\u263D\u25EF\u263E\u208A\u2027\u207A\u02D6\u22C6</p><h3>Your basket is empty</h3><p style="color:var(--muted);margin:10px 0 18px">Time to find some treasure.</p><a class="btn btn--amber" href="/collections/all">Start shopping</a></div>';
      return;
    }
    var html = '';
    if (threshold > 0) {
      var remaining = threshold - cart.total_price;
      if (remaining > 0) {
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        html += '<div class="cart-progress">You are ' + money(remaining) + ' away from free UK delivery<div class="cart-progress__track"><div class="cart-progress__fill" style="width:' + pct + '%"></div></div></div>';
      } else {
        html += '<div class="cart-progress">You have earned free UK delivery.</div>';
      }
    }
    // Offer bars render whenever a real offer is configured and an item qualifies -
    // not gated by the homepage promo toggle, so the cart tracker always works.
    html += offerBars(cart);
    var anyWrapped = false;
    cart.items.forEach(function (item) {
      var wrapped = !!(item.properties && item.properties['Gift wrap'] === 'Yes');
      if (wrapped) anyWrapped = true;
      html += '<div class="cart__item">' +
        '<a href="' + item.url + '"><img src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '') + '" alt="" loading="lazy"></a>' +
        '<div><a href="' + item.url + '" style="font-weight:700">' + item.product_title + '</a>' +
        (item.variant_title ? '<div style="font-size:.82rem;color:var(--muted)">' + item.variant_title + '</div>' : '') +
        '<label class="wrap-tick"><input type="checkbox" data-wrap-line="' + item.key + '"' + (wrapped ? ' checked' : '') + '> Gift wrap - free</label>' +
        '<div class="qty" style="margin-top:8px"><button type="button" data-qty="down" data-line="' + item.key + '">-</button><input type="text" value="' + item.quantity + '" data-line-input="' + item.key + '" inputmode="numeric"><button type="button" data-qty="up" data-line="' + item.key + '">+</button></div></div>' +
        '<div style="text-align:right"><div class="price tnum">' + money(item.final_line_price) + '</div><button type="button" class="link-remove" data-remove="' + item.key + '" style="font-size:.78rem;color:var(--muted);margin-top:8px;background:none;border:0;text-decoration:underline;cursor:pointer">Remove</button></div>' +
        '</div>';
    });
    if (anyWrapped) {
      html += '<p class="wrap-note">\uD83C\uDF80 Each ticked item is wrapped as its own gift; multiples of the same item are wrapped together.</p>';
    }
    html += '<div class="cart__totals"><div class="cart__subtotal tnum">Subtotal: ' + money(cart.total_price) + '</div>' +
      '<a class="btn btn--amber btn--full" href="/checkout" style="margin-top:6px">Checkout</a>' +
      '<a class="btn btn--outline btn--full" href="/cart" style="margin-top:8px">View basket</a>' +
      '<p class="cart-trust">Secure checkout &middot; Free gift wrapping available' + (threshold > 0 ? ' &middot; Free UK delivery from ' + money(threshold) : '') + '</p></div>';
    body.innerHTML = html;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* ---------- Per-item gift wrapping ----------
     The tick writes a visible "Gift wrap: Yes" line-item property, so it appears against
     that item at checkout, on the order in admin, and on the packing slip. Free, no app.
     GOTCHA: /cart/change.js silently IGNORES an empty properties object, so "remove the
     last property" cannot be done with change - unticking a line whose only property is
     Gift wrap must remove the line and re-add it clean (which also merges it back into
     any identical unwrapped line). Properties changes give lines NEW keys, so the cart
     PAGE reloads after a toggle; the drawer re-renders from the returned cart. */
  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart request failed'); return r.json(); });
  }
  function setWrap(key, on) {
    return fetchCart().then(function (cart) {
      var it = cart.items.filter(function (x) { return x.key === key; })[0];
      if (!it) return Promise.reject(new Error('line not found'));
      var props = {};
      var src = it.properties || {};
      Object.keys(src).forEach(function (k) { if (k !== 'Gift wrap') props[k] = src[k]; });
      if (on) props['Gift wrap'] = 'Yes';
      if (Object.keys(props).length > 0) {
        return jsonPost('/cart/change.js', { id: key, quantity: it.quantity, properties: props });
      }
      // Unticking the only property: change.js would ignore {} - remove the line, re-add it clean.
      return jsonPost('/cart/change.js', { id: key, quantity: 0 })
        .then(function () { return jsonPost('/cart/add.js', { id: it.variant_id || it.id, quantity: it.quantity }); })
        .then(fetchCart);
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-wrap-line]');
    if (!t) return;
    var key = t.getAttribute('data-wrap-line');
    var inDrawer = !!t.closest('#cart-drawer');
    t.disabled = true;
    setWrap(key, t.checked).then(function (cart) {
      if (inDrawer) { renderCart(cart); }
      else { window.location.reload(); }
    }).catch(function () {
      t.checked = !t.checked;
      t.disabled = false;
    });
  });
  document.addEventListener('click', function (e) {
    var rem = e.target.closest('[data-remove]');
    if (rem) { changeLine(rem.getAttribute('data-remove'), 0); return; }
    var qb = e.target.closest('.cart__item [data-qty]');
    if (qb) {
      var line = qb.getAttribute('data-line');
      var inp = document.querySelector('[data-line-input="' + line + '"]');
      var val = parseInt(inp.value, 10) || 1;
      val += (qb.getAttribute('data-qty') === 'up' ? 1 : -1);
      if (val < 0) val = 0;
      changeLine(line, val);
    }
  });

  /* Add to cart (progressive enhancement) */
  document.querySelectorAll('form[action$="/cart/add"], form.product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('data-label', btn.textContent); btn.textContent = 'Adding...'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) { renderCart(cart); openDrawer(document.getElementById('cart-drawer')); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || 'Add'; } });
    });
  });

  // Open cart drawer from header (and preload contents)
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart().then(function (cart) { renderCart(cart); openDrawer(document.getElementById('cart-drawer')); });
    });
  });

  /* ---------- Quick view ---------- */
  var qv = document.getElementById('qv');
  var qvBody = document.getElementById('qv-body');
  function openQV() {
    if (!qv) return;
    qv.classList.add('is-open'); qv.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeQV() {
    if (!qv || !qv.classList.contains('is-open')) return;
    qv.classList.remove('is-open'); qv.setAttribute('aria-hidden', 'true');
    if (overlay && !document.querySelector('.drawer.is-open')) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function sizedImg(url, w) { return url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; }
  function loadQV(handle) {
    if (!qv || !qvBody) return;
    qvBody.innerHTML = '<div class="qv__loading">Loading&hellip;</div>';
    openQV();
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var firstVar = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        var opts = '';
        if (p.variants.length > 1) {
          opts = '<select class="select" id="qv-variant" style="margin-top:4px">' + p.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + v.title + ' - ' + money(v.price) + (v.available ? '' : ' (sold out)') + '</option>';
          }).join('') + '</select>';
        }
        var desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        if (desc.length > 260) desc = desc.slice(0, 260) + '…';
        qvBody.innerHTML =
          '<div class="qv__media">' + (img ? '<img src="' + sizedImg(img, 640) + '" alt="' + p.title + '">' : '') + '</div>' +
          '<div class="qv__info">' +
            (p.type ? '<span class="eyebrow">' + p.type + '</span>' : '') +
            '<h2 class="qv__title">' + p.title + '</h2>' +
            '<div class="qv__price" id="qv-price">' + money(firstVar.price) + '</div>' +
            opts +
            '<button class="btn btn--amber btn--full" id="qv-add" data-var="' + firstVar.id + '"' + (firstVar.available ? '' : ' disabled') + '>' + (firstVar.available ? 'Add to basket' : 'Sold out') + '</button>' +
            (desc ? '<p class="qv__desc">' + desc + '</p>' : '') +
            '<a class="qv__full" href="' + p.url + '">View full details &rarr;</a>' +
          '</div>';
        var sel = document.getElementById('qv-variant');
        var addBtn = document.getElementById('qv-add');
        var priceEl = document.getElementById('qv-price');
        if (sel) {
          sel.addEventListener('change', function () {
            var v = p.variants.filter(function (x) { return x.id == sel.value; })[0];
            if (!v) return;
            if (priceEl) priceEl.textContent = money(v.price);
            if (addBtn) { addBtn.setAttribute('data-var', v.id); addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to basket' : 'Sold out'; }
          });
        }
        if (addBtn) {
          addBtn.addEventListener('click', function () {
            var id = addBtn.getAttribute('data-var');
            addBtn.disabled = true; addBtn.textContent = 'Adding...';
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
              .then(function (r) { return r.json(); })
              .then(function () { return fetchCart(); })
              .then(function (cart) { renderCart(cart); closeQV(); openDrawer(document.getElementById('cart-drawer')); })
              .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Add to basket'; });
          });
        }
      })
      .catch(function () {
        qvBody.innerHTML = '<div class="qv__loading">Sorry, we could not load this one. <a href="/products/' + handle + '">View the product page</a>.</div>';
      });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quick-view]');
    if (t) { e.preventDefault(); e.stopPropagation(); loadQV(t.getAttribute('data-quick-view')); return; }
    if (e.target.closest('[data-qv-close]')) { closeQV(); return; }
    if (qv && qv.classList.contains('is-open') && (e.target === overlay || e.target === qv)) { closeQV(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest('[data-quick-view]');
    if (t) { e.preventDefault(); loadQV(t.getAttribute('data-quick-view')); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQV(); });

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('[data-reveal]');
  function revealAll() { reveals.forEach(function (el) { el.classList.add('is-in'); }); }
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealAll();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        setTimeout(function () { el.classList.add('is-in'); }, (i % 4) * 70);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    reveals.forEach(function (el) { io.observe(el); });
    // safety net: never leave content hidden if something misses
    setTimeout(revealAll, 1600);
  }

  /* ---------- Graceful image fallback ---------- */
  function fail(img) {
    var holder = img.closest('.ph');
    if (holder) holder.classList.add('is-fallback');
    img.style.display = 'none';
  }
  Array.prototype.forEach.call(document.images, function (img) {
    if (img.complete && img.naturalWidth === 0) fail(img);
    img.addEventListener('error', function () { fail(img); });
  });

  /* ---------- Announcement rotates on small screens ---------- */
  var items = document.querySelectorAll('.notice__item');
  if (items.length > 1) {
    var idx = 0;
    setInterval(function () {
      if (window.innerWidth >= 900) return;
      items[idx].classList.remove('is-on');
      idx = (idx + 1) % items.length;
      items[idx].classList.add('is-on');
    }, 4200);
  }

  /* ---------- Hero photo rotator ----------
     Desktop only (Baymard: no auto-rotating imagery on mobile, where the photo sits behind
     the headline), and only when motion is allowed. Slides 2-5 ship as data-src and are
     promoted ONE CYCLE AHEAD of when they show - a phone visitor pays for one hero photo,
     not five, and a desktop visitor downloads one slide at a time, never four in a burst. */
  var heroSlides = document.querySelectorAll('.hero__slide');
  var heroStarted = false;
  function promoteSlide(s) {
    if (s && s.getAttribute('data-src')) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); }
  }
  function startHeroRotation() {
    if (heroStarted) return;
    heroStarted = true;
    promoteSlide(heroSlides[1]);
    var hIdx = 0;
    setInterval(function () {
      heroSlides[hIdx].classList.remove('is-active');
      heroSlides[hIdx].setAttribute('aria-hidden', 'true');
      hIdx = (hIdx + 1) % heroSlides.length;
      heroSlides[hIdx].classList.add('is-active');
      heroSlides[hIdx].removeAttribute('aria-hidden');
      promoteSlide(heroSlides[(hIdx + 1) % heroSlides.length]);
    }, 9000);
  }
  if (heroSlides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var heroMq = window.matchMedia('(min-width: 900px)');
    if (heroMq.matches) { startHeroRotation(); }
    else if (heroMq.addEventListener) { heroMq.addEventListener('change', function (e) { if (e.matches) startHeroRotation(); }); }
  }

  /* ---------- Hero featured-collection button ----------
     Rotates the ghost CTA through the best-selling collections (Liquid prints them in
     #gh-hero-collections). Text-only, so it runs on mobile too; offset half a photo
     cycle so the button and the photo never change in the same instant. */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cta = document.getElementById('hero-rotator-cta');
    var data = document.getElementById('gh-hero-collections');
    if (!cta || !data) return;
    var cols = [];
    try { cols = JSON.parse(data.textContent) || []; } catch (e) { return; }
    if (cols.length < 2) return;

    /* Wrap the label in a stacked slot so two labels can overlap and TRULY
       cross-fade - the old one fades out while the new one fades in, so the
       button is never empty for a frame. Both live in one grid cell, so the
       slot always sizes to the wider label and the row never jumps. */
    var slot = document.createElement('span');
    slot.className = 'hrc__slot';
    var current = document.createElement('span');
    current.className = 'hrc__label';
    current.textContent = cta.textContent.trim();
    slot.appendChild(current);
    cta.textContent = '';
    cta.appendChild(slot);

    var idx = 0, busy = false;
    function nextCollection() {
      if (busy) return;
      busy = true;
      idx = (idx + 1) % cols.length;
      var incoming = document.createElement('span');
      incoming.className = 'hrc__label is-entering';
      incoming.textContent = cols[idx].label;
      slot.appendChild(incoming);
      cta.setAttribute('href', cols[idx].url);
      var outgoing = current;
      /* two frames so the browser paints the start state before transitioning */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          outgoing.classList.add('is-leaving');
          incoming.classList.remove('is-entering');
        });
      });
      setTimeout(function () {
        if (outgoing.parentNode) { outgoing.parentNode.removeChild(outgoing); }
        busy = false;
      }, 1150);
      current = incoming;
    }
    setTimeout(function () { nextCollection(); setInterval(nextCollection, 27000); }, 8000);
  })();

  /* ---------- Gallery lightbox ---------- */
  var lbItems = document.querySelectorAll('[data-lightbox]');
  if (lbItems.length) {
    var lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML = '<button class="lightbox__close" type="button" aria-label="Close">×</button><img alt="">';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('img');
    function lbClose() { lb.classList.remove('is-open'); document.body.style.overflow = ''; lbImg.removeAttribute('src'); }
    lbItems.forEach(function (it) {
      it.addEventListener('click', function () {
        lbImg.src = it.getAttribute('data-lightbox');
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('.lightbox__close')) lbClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) lbClose(); });
  }

  /* ---------- Collection filters: force the dropdown OPEN on desktop so it renders as a
       sidebar (CSS alone can't reliably show a closed <details>' content); toggleable on mobile. */
  var facetsEl = document.querySelector('.facets-collapse');
  if (facetsEl) {
    var fitFacets = function () { if (window.innerWidth >= 900) { facetsEl.open = true; } };
    fitFacets();
    window.addEventListener('resize', fitFacets);
  }

  /* ---------- Collections dropdown: close on outside click or Escape (a native <details>
       stays open otherwise). Clicking a link navigates away, so nothing else is needed. */
  var colDd = document.getElementById('collections-dd');
  if (colDd) {
    var colTray = document.getElementById('collections-tray');
    // If the header is mid-hide when the accordion opens, bring it straight back.
    colDd.addEventListener('toggle', function () {
      if (colDd.open && head) { head.classList.remove('head--hidden'); }
    });
    document.addEventListener('click', function (e) {
      if (colDd.open && !colDd.contains(e.target) && !(colTray && colTray.contains(e.target))) { colDd.open = false; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && colDd.open) { colDd.open = false; }
    });
  }

  /* ---------- Predictive search ----------
     Live suggestions from Shopify's /search/suggest.json under both search boxes
     (desktop inline bar + mobile drop-down). Progressive enhancement: without JS the
     forms still submit to /search. */
  function attachSuggest(input) {
    if (cloudSearchPresent) return;
    var form = input.closest('form');
    if (!form) return;
    form.classList.add('has-suggest');
    var panel = document.createElement('div');
    panel.className = 'suggest';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    form.appendChild(panel);
    var timer = null, lastQ = '';
    function close() { panel.hidden = true; panel.innerHTML = ''; lastQ = ''; }
    function render(q, products) {
      if (!products.length) { close(); return; }
      var html = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        return '<a class="suggest__item" role="option" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="44" height="44">' : '<span class="suggest__ph"></span>') +
          '<span class="suggest__title">' + ghEsc(p.title) + '</span>' +
          (p.price ? '<span class="suggest__price tnum">£' + ghEsc(p.price) + '</span>' : '') +
          '</a>';
      }).join('');
      html += '<a class="suggest__all" href="/search?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + ghEsc(q) + '&rdquo; &rarr;</a>';
      panel.innerHTML = html;
      panel.hidden = false;
    }
    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        lastQ = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (q !== lastQ) return;
            var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
            render(q, prods);
          })
          .catch(close);
      }, 220);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }
  document.querySelectorAll('.hsearch input[type="search"], .header-search input[type="search"]').forEach(attachSuggest);
})();
